<template>
  <div
    @click="e => $emit('click', e)"
    class="app-select-item"
    :class="{ 'primary-background-color': selected }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppSelectItem',

  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-select-item {
  padding: 1rem;

  &.selected {
    background-color: red;
  }
}
</style>
